import { apiRequest } from "@core/services/api/apiRequest";
import { VIDEO_API } from "../videoMeeting.constants";
import type { Meeting } from "@core/features/meeting";

export const fetchUserMeetings = async (): Promise<Meeting[]> => {
  return apiRequest(VIDEO_API.USER_MEETINGS, "GET");
};
